export class SelectedOrderModel {
  dossierNumber: string;
  flightDetailsIdentifier: string;
}
